import { Header } from '@app/@core/data/models/header.model';
import { createAction, props } from '@ngrx/store';

export enum SeoActions {
  SEO_SET_TITLE = '[Seo] Set title',
  SEO_SET_DESCRIPTION = '[Seo] Set  description',
  SEO_SET_HEADER = '[Seo] Set  header',
}

export const setTitle = createAction(
  SeoActions.SEO_SET_TITLE,
  props<{ title: string }>(),
);
export const setDescription = createAction(
  SeoActions.SEO_SET_DESCRIPTION,
  props<{ description: string }>(),
);

export const setHeader = createAction(
  SeoActions.SEO_SET_HEADER,
  props<{ payload: { header: Header} }>()
);
